/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState, useRef } from 'react';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Material components
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

import LeasesService from "services/leases-service";
import PaymentsService from "services/payments-service";
import PropertyService from "services/property-service";

export default function PropertiesData() {
  const [propertiesData, setPropertiesData] = useState([])
  const [rows, setRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [innerLoading, setInnerLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [open, setOpen] = useState(false);
  const [isShowDialog, setIsShowDialog] = useState(false);
  const [editedRow, setEditedRow] = useState(null);
  const [sortField, setSortField] = useState("lease_number"); // default sort field
  const [sortDirection, setSortDirection] = useState("desc"); // default sort direction
  const totalRows = useRef(0);

  const getPropertyList = async (pageIndex = '', pageSize = '', filter = "", sortField="updated_at", sortDirection="desc") => {
    try {
      setInnerLoading(true);
      setButtonDisabled(true)
      const data = await PropertyService.getList({
        limit: pageSize,
        page: pageIndex,
        sortField: sortField,
        sortDirection: sortDirection,
        filter: filter
      })
      setTotalPages(data.meta.last_page);
      totalRows.current = data.meta.total;
      const paymentsList = data.data.map(({ id, amount,  payment_method: { display_name }, payment_date, tenant: { business_name, tenant_code, physical_address },  property: { property_name }, unit_names, agreement_doc, rent_amount, rent_deposit, due_date, tenants, total, receipt_number, status: { status_class, status_icon, status_text } }) => ({
        id, 
        amount,
        payment_method_id: display_name,
        tenant_id: business_name,
        physical_address,
        lease_id: tenant_code,
        payment_date,
        property_id: property_name,
        unit_names, 
        agreement_doc: agreement_doc, 
        rent_amount, 
        rent_deposit,
        tenants,
        total,
        receipt_number
      }));

      setPaymentsData(paymentsList);
    } catch (error) {
      console.error('Error get payments list:', error);
    } finally {
      setButtonDisabled(false);
      setInnerLoading(false);
    }
  }

  const getPropertyLeasesList = async (pageIndex = '', pageSize = '', filter = "", sortField="updated_at", sortDirection="desc", propertyId) => {
    try {
      setInnerLoading(true);
      setButtonDisabled(true)
      const data = await PropertyService.getPropertyLeasesList({
        limit: pageSize,
        page: pageIndex,
        sortField: sortField,
        sortDirection: sortDirection,
        filter: filter
      }, propertyId);
      setTotalPages(data.meta.last_page);
      totalRows.current = data.meta.total;

      // const propertiesList = data.data.map(({ id, amount,  payment_method: { display_name }, payment_date, tenant: { business_name, tenant_code },  property: { property_name }, unit_names, agreement_doc, rent_amount, due_date, tenants, total, receipt_number, status: { status_class, status_icon, status_text } }) => ({
      //   id, 
      //   amount,
      //   payment_method_id: display_name,
      //   tenant_id: business_name,
      //   lease_id: tenant_code,
      //   payment_date,
      //   property_id: property_name,
      //   unit_names, 
      //   agreement_doc: agreement_doc || "", 
      //   rent_amount, 
      //   tenants,
      //   total,
      //   receipt_number,
      //   status_class,
      //   status_icon,
      //   status_text
      // }));
      console.log(data.data);
      const propertiesList = data.data.map(({ id, lease_code, tenants, unit_names, rent_amount, rent_deposit, lease_type: { lease_type_display_name }, due_on, billed_on, tenant_names, agreement_doc, status: { status_color, status_text, status_icon }, area_size, remarks  }) => {
        let price_per_sqft = "N/A";
        if (parseInt(area_size) > 0) {
          price_per_sqft = (rent_amount / parseInt(area_size)).toFixed(2);
        }

        let physical_address = '';
        if (tenants && tenants.length > 0) {
          physical_address = tenants[0].physical_address || '';
        }

        return {
          id,
          lease_code,
          unit: unit_names,
          rent_amount,
          rent_deposit,
          lease_type: lease_type_display_name,
          due_on,
          last_billing: billed_on,
          tenant_names,
          physical_address,
          tenants,
          area: area_size,
          price_per_sqft: price_per_sqft,
          remarks: remarks,
          status_color,
          status_text,
          status_icon,
          agreement_doc: agreement_doc, 
        }
      });
      // console.log('propertiesList', propertiesList);
      setPropertiesData(propertiesList);
      // console.log('data', data);
    } catch (error) {
      console.error('Error get properties list:', error);
    } finally {
      setButtonDisabled(false);
      setInnerLoading(false);
    }
  }

  const getPropertyLeasesExcel = async (pageIndex = '', pageSize = '', filter = "", sortField="updated_at", sortDirection="desc", propertyId) => {
    try {
      setInnerLoading(true);
      setButtonDisabled(true)
      const data = await PropertyService.getPropertyLeasesExcel({
        limit: 100000, // Fetching all records for Excel export
        page: pageIndex,
        sortField: sortField,
        sortDirection: sortDirection,
        // filter: filter
      }, propertyId);
      setTotalPages(data.meta.last_page);
      totalRows.current = data.meta.total;

      const propertiesList = data.data.map(({ id, lease_code, property: {property_code}, tenants, unit_names, rent_amount, lease_type: { lease_type_display_name }, due_on, billed_on, tenant_names, status: { status_color, status_text, status_icon }, area_size, remarks  }) => {
        let price_per_sqft = "N/A";
        if (parseInt(area_size) > 0) {
          price_per_sqft = (rent_amount / parseInt(area_size)).toFixed(2);
        }

        return {
          "Property Code": property_code,
          "Tenant Code": lease_code,
          "Rent Amount": rent_amount,
          "Tenant Name": tenant_names,
          "Area Size": area_size,
          "price per square foot": price_per_sqft,
          "Remarks": remarks
        }
      });
      
      return propertiesList;
    } catch (error) {
      console.error('Error get properties list:', error);
      return [];
    } finally {
      setButtonDisabled(false);
      setInnerLoading(false);
    }
    return [];
  }

  const handleEditPayment = (item) => {
    setOpen(true);
    setIsShowDialog(true);
    setEditedRow(item);
  }

  const handleEditLease = (item) => {
    setOpen(true);
    setIsShowDialog(true);
    setEditedRow(item);
  }

  useEffect(() => {
    const data = propertiesData.map((item, index) => ({
      ...item,
      no: index,
      area: item?.area || "N/A",
      price_per_sqft: item?.price_per_sqft || "N/A",
      remarks: item?.remarks || "N/A",
      status: (
        <MDBox ml={-1} className={`${item.status_color}`} display="flex" alignItems="center">
          <Icon fontSize="14px">{item.status_icon}</Icon>
          <MDTypography component="span" fontSize="14px" sx={{ marginLeft: "5px", fontWeight: "400" }} className={`${item.status_color}`}>
            {item.status_text}
          </MDTypography>
        </MDBox>
      ),
      action: (
        <MDTypography component="a" href="#" color="text">
          <IconButton size="small" onClick={() => handleEditLease(item)} ><Icon>edit</Icon></IconButton>
        </MDTypography>
      ),
    }));
    setRows(data);
  }, [propertiesData]);

  // console.log('rows', rows)

  return {
    columns: [
      { Header: "Tenant Code", accessor: "lease_code", align: "left" },
      { Header: "Tenant Name", accessor: "tenant_names", align: "left" },
      { Header: "Lease Address", accessor: "agreement_doc", align: "left" },
      { Header: "Unit", accessor: "unit", align: "left" },
      { Header: "Rent Amount", accessor: "rent_amount", align: "left", contentWidth: "125px"},
      { Header: "Rent Deposit", accessor: "rent_deposit", align: "left" },
      { Header: "Area Size", accessor: "area", align: "left" },
      { Header: "price per square foot", accessor: "price_per_sqft", align: "left", contentWidth: "92px"},
      { Header: "Remarks", accessor: "remarks", align: "left" },
      { Header: "Status", accessor: "status", align: "left" },
      { Header: "Actions", accessor: "action", enableSorting: false, align: "left" }
    ],
    rows: rows,
    totalPages: totalPages,
    getPropertyLeasesList: getPropertyLeasesList,
    getPropertyLeasesExcel: getPropertyLeasesExcel,
    innerLoading: innerLoading,
    buttonDisabled: buttonDisabled,
    setButtonDisabled: setButtonDisabled,
    open: open,
    setOpen: setOpen,
    isShowDialog: isShowDialog,
    sortField: sortField,
    setSortField: setSortField,
    sortDirection: sortDirection,
    setSortDirection: setSortDirection,
    editedRow: editedRow,
    totalRows: totalRows
  };
}
